
import { filter } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { WireService } from '../../services/wire.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { WireApi } from '../../../../api/wire/wire.api';
import { ReleaseStatsModel } from '../../models/release-stats.model';
import { WireModel } from '../../models/wire.model';
import moment from 'moment-timezone';
import { download } from '../../../../Common/Misc/helpers/download/download.helper';


export enum WireReportTypes {
    performance,
    composition
}


@Injectable()
export class WireReportService implements OnDestroy {

    currentWire: WireModel;
    timezone: string;
    performanceReport: ReleaseStatsModel;
    performanceReport$: BehaviorSubject<ReleaseStatsModel> = new BehaviorSubject<ReleaseStatsModel>(null);
    performanceReportLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    userId: string;
    accountId: string;
    subscriptions: Subscription[] = [];

    constructor(
        public wireApi: WireApi,
        public wireService: WireService
    ) {
        this.subscriptions.push(
            this.wireService.currentResource$.pipe(filter(x => !!x)).subscribe(wire => {
                if (!wire.id) {
                    return;
                }
                this.currentWire = wire;
                this.performanceReportLoading$.next(true);
                this.wireApi.getPerformanceReport(wire.id).subscribe(releaseStats => {
                    this.performanceReport = !!releaseStats ? new ReleaseStatsModel(releaseStats) : null;
                    this.performanceReport$.next(this.performanceReport);
                    this.performanceReportLoading$.next(false);
                });
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    async exportCSVReport() {
        const currentDate = moment().format('YYYYMMDD');
        this.wireApi.getCSVReport(this.currentWire.id, currentDate).subscribe(x => {
            download.blob(x, `${this.currentWire.name.split(' ').join('_').substring(0, 80)}_${this.currentWire.id}_Performance_${currentDate}`);
        });
    }

    getPerformanceReport(): Observable<ReleaseStatsModel> {
        return this.performanceReport$;
    }

    getPerformanceReportLoading(): Observable<boolean> {
        return this.performanceReportLoading$;
    }
}
